import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

const MIGRATED_VERSION:DesignerVersion = 36;

export const migration_35_36:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            const boxIdToPageIdMap = {};
            const bindingIdToPropIdMap = {};
            const slotIdToLocationMap = {};
            const newBindings = {};
            const newNamedRanges = {};

            if( designState.surface.onApplicationLoadProp.bindingId )
                bindingIdToPropIdMap[designState.surface.onApplicationLoadProp.bindingId] = designState.surface.onApplicationLoadProp.id;

            if( designState.surface.onViewportResizeProp.bindingId )
                bindingIdToPropIdMap[designState.surface.onViewportResizeProp.bindingId] = designState.surface.onViewportResizeProp.id;

            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {componentDesc} = boxSnapshot;

                        removeBindGroups(componentDesc._properties, bindingIdToPropIdMap, designState.bindings);
                        removeBindGroups(componentDesc._baseProperties, bindingIdToPropIdMap, designState.bindings);
                        removeBindGroups(componentDesc._layoutProperties, bindingIdToPropIdMap, designState.bindings);
                        collectEventProps(componentDesc._eventProps, bindingIdToPropIdMap);
                        collectEventProps(componentDesc._baseEventProps, bindingIdToPropIdMap);

                        boxIdToPageIdMap[boxSnapshot.id] = page.id;
                    });
                }
            });

            const workbook:any = Object.values(designState.spreadsheets.workbooks)[0];
            workbook.runtime.sheets.forEach((sheet:any) =>
            {
                Object.values(sheet.slots || {}).forEach((slot:any) =>
                {
                    slotIdToLocationMap[slot.id] = slot.location;
                });
            });
            workbook.runtime.namedRanges = newNamedRanges;

            if( designState.bindings )
            {
                Object.values(designState.bindings).forEach((binding:any) =>
                {
                    if( !bindingIdToPropIdMap[binding.id] )
                        return;

                    const {id, path, boxId, direction, eventPropName, type} = binding;

                    const pageId = boxId && boxIdToPageIdMap[boxId];
                    const propId = bindingIdToPropIdMap[binding.id];

                    const sheetId = binding.sheetId || binding.vectors[0].sheetId;
                    const slotId = binding.slotId || binding.vectors[0].slotId;
                    const useFormat = (binding.useFormat || (binding.vectors && binding.vectors[0].useFormat)) === 'useFormat' || null;
                    const repeaterFixation = binding.fixedDirection || binding.vectors[0].fixedDirection;

                    const isPropBinding = !eventPropName;

                    const rangeId = IdUtil.newGUID();
                    const rangeLocation = slotIdToLocationMap[slotId];
                    const rangeFramePath = binding.pathInFrame || (binding.vectors && binding.vectors[0].pathInFrame);
                    let rangeRowCount = 1;
                    let rangeColCount = 1;
                    if( type !== 'scalar' )
                    {
                        const propLength = binding.vectors[0].count || -1;
                        const propWidth = binding.vectors.length;

                        rangeRowCount = direction === 'downDirection' ? propLength : propWidth;
                        rangeColCount = direction === 'downDirection' ? propWidth : propLength;
                    }

                    newNamedRanges[rangeId] = {
                        id: rangeId,
                        name: null,
                        sheetId,
                        location: rangeLocation,
                        framePath: rangeFramePath,
                        rowCount: rangeRowCount,
                        colCount: rangeColCount
                    };

                    const newBinding = {
                        id,
                        sheetId,
                        pageId,
                        boxId,
                        propId,
                        rangeId,
                        repeaterFixation,
                        isPropBinding
                    } as any;

                    if( isPropBinding )
                    {
                        newBinding.propPath = path.fieldPath.replace(/\[(\d+)\]/g, '.$1');
                        newBinding.direction = direction || 'downDirection';
                        newBinding.useFormat = useFormat;
                    }

                    newBindings[id] = newBinding;
                });

                designState.bindings = newBindings;
            }
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function collectEventProps(eventPropsMap, bindingIdToPropIdMap)
{
    Object.values(eventPropsMap)
        .filter((eventProp:any) => eventProp.bindingId)
        .forEach((eventProp:any) =>
            bindingIdToPropIdMap[eventProp.bindingId] = eventProp.id
        );
}

function removeBindGroups(propsMap, bindingIdToPropIdMap, bindings)
{
    const collectBindingIdsFn = (bindGroupItem, bindingIds) =>
    {
        if( !bindGroupItem )
            return;

        const {bindingId, paths} = bindGroupItem;

        if( bindingId && bindings[bindingId] )
            bindingIds.push(bindingId);

        if( paths )
        {
            paths.forEach(itemMap =>
                Object.values(itemMap).forEach(childItem =>
                    collectBindingIdsFn(childItem, bindingIds)
                )
            );
        }
    };

    Object.values(propsMap).forEach((prop:any) =>
    {
        const bindingIds = [];
        Object.values(prop._bindGroups).forEach((bindGroup:any) =>
            collectBindingIdsFn(bindGroup.rootBindItem, bindingIds)
        );

        bindingIds.forEach(bindingId =>
            bindingIdToPropIdMap[bindingId] = prop.id
        );

        delete prop._bindGroups;
        prop.bindingIds = bindingIds;
    });
}
